import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TerraPower from "../../components/icons/TerraPower";
import Natrium from "../../components/icons/Natrium";
import BaseSystem from "../../components/BaseSystem";
import Select from 'react-select';
import DecarbonizedSystem from "../../components/DecarbonizedSystem";
import Slider from "rc-slider";
import StackedChart from "../../components/StackedChart/StackedChart";
import HotColdChart from "../../components/HotColdChart";
import "./index.scss";
import { useData } from "../../context/DataProvider";
import { buildMediaSlideshow } from "../../utils/media";
import Carousel from "../../components/Carousel";

const LEDView = () => {
    const [scenario, setScenario] = useState<string>("S1");
    const [period, setPeriod] = useState<string>("1");
    //const { config } = useData()!;
    
    const percentageOptions = [
        {value: "S1", label: "30%"},
        {value: "S2", label: "40%"},
        {value: "S3", label: "50%"},
        {value: "S4", label: "60%"},
        {value: "S5", label: "70%"},
        {value: "S6", label: "80%"},
        {value: "S7", label: "90%"},
        {value: "S8", label: "100%"}
    ]
    useEffect(()=>{
        setScenario("S1");
        setPeriod("0");
    }, [])
    const scenarioNatrium = (percent: string) => {
        switch(percent){
            case "S1":
                return "70%";
            case "S2":
                return "60%";
            case "S3":
                return "50%";
            case "S4":
                return "40%";
            case "S5":
                return "30%";
            case "S6":
                return "20%";
            case "S7":
                return "10%";
            case "S8":
                return "0%";
        }
    }

    const sliderMarks = {
        12: 12,
        24: 24,
        36: 36,
        48: 48,
        60: 60,
        72: 72
    }

    return(
        <div className="page ledPage">
            <div className="logos">
                <TerraPower />
                <Natrium />
            </div>
            <BaseSystem scenario={scenario} led={true}/>
            <div className="right-half">
                <div className="left-inner">
                    <div className="header">
                        ADJUST DECARBONIZATION GENERATION MIX
                    </div>
                    <div className="renewables-natrium">
                        <div className="renewables">
                            <span className="renewables-label">Renewables</span>
                            <Select 
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={percentageOptions} 
                            onChange={(e: any)=>{
                                setScenario(e.value);
                            }}
                            unstyled
                            placeholder="30%"
                            isSearchable={false}
                            onMenuOpen={()=>{
                            }}
                            />

                        </div>
                        <div className="natrium">
                            <span className="natrium-label">Natrium</span>
                            <span>{scenarioNatrium(scenario)}</span>
                        </div>
                    </div>
                    <div className="carbon-wrapper">
                        <DecarbonizedSystem scenario={scenario} led={true}/>
                    </div>
                </div>
                <div className="right-inner">
                    <div className="header">
                        SELECT HOUR TO PREVIEW DATA
                    </div>
                    <div className="slider-wrapper">
                        <Slider 
                        min={0}
                        max={72}
                        
                        marks={sliderMarks}
                        dots
                        railStyle={{ backgroundColor: 'transparent'}}
                        onChange={(value) => {
                            setPeriod(`${value}`);
                        }}
                        //handleRender={sliderThumb}
                        style={{"--value": period} as React.CSSProperties}
                        />
                    </div>
                    <div className="graphs-container">
                        <div className="header">2050 ENERGY SYSTEM OUTPUT BY GENERATION SOURCE (MWH)</div>
                        <StackedChart scenario={scenario} period={period === "0" ? "72" : period} led={true}/>
                        <div className="header-2">NATRIUM ENERGY STORAGE PERFORMANCE</div>
                        <HotColdChart scenario={scenario} period={period === "0" ? "1" : period} led={true}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LEDView;